import http from '@/services/http';
import apiEndpoints from '@/services/apiEndpoints';

const getDefaultState = () => {
  return {};
};

const state = getDefaultState();
const getters = {};
const mutations = {};

const actions = {
  async uploadImages (_, payload) {
    return await http.post(apiEndpoints.uploadImages, payload);
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
